// src/components/mobile/MobileCollapsible.tsx
import React, { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import '../../styles/mobile/mobile-common.css';

interface MobileCollapsibleProps {
  title: string;
  count?: number;
  defaultOpen?: boolean;
  maxHeight?: string;
  children: React.ReactNode;
  className?: string;
}

export const MobileCollapsible: React.FC<MobileCollapsibleProps> = ({
  title,
  count,
  defaultOpen = false,
  maxHeight = '150px',
  children,
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={`mobile-collapsible ${className}`} style={{ marginBottom: 'var(--space-2)' }}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="mobile-collapsible-header"
        style={{
          width: '100%',
          height: '32px',
          display: 'flex',
          alignItems: 'center',
          gap: 'var(--space-2)',
          padding: '0 var(--space-3)',
          background: 'var(--gray-50)',
          border: '1px solid var(--gray-200)',
          borderRadius: 'var(--radius-sm)',
          cursor: 'pointer',
          fontSize: 'var(--mobile-body)',
          fontWeight: 600,
          color: 'var(--gray-900)',
          transition: 'all 0.2s ease'
        }}
        aria-expanded={isOpen}
      >
        <ChevronRight
          size={14}
          style={{
            transition: 'transform 0.3s ease',
            transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)'
          }}
        />
        <span style={{ flex: 1, textAlign: 'left' }}>{title}</span>
        {count !== undefined && (
          <span
            style={{
              fontSize: 'var(--mobile-tiny)',
              background: 'var(--gray-200)',
              color: 'var(--gray-600)',
              padding: '2px 6px',
              borderRadius: 'var(--radius-sm)',
              fontWeight: 600
            }}
          >
            {count}
          </span>
        )}
      </button>
      
      <div
        className="mobile-collapsible-content"
        style={{
          maxHeight: isOpen ? maxHeight : '0',
          overflow: isOpen ? 'auto' : 'hidden',
          transition: 'max-height 0.3s ease',
          marginTop: isOpen ? 'var(--space-2)' : '0'
        }}
      >
        {children}
      </div>
    </div>
  );
};
